import { Box } from "@mui/material";
import React from "react";
import Header from "components/Header";
import AddExpense from "./AddExpense";
import Cards from "./Cards";
import ExpenseAnalytics from "./Analytics/ExpenseAnalytics";
import ExpenseTable from "./ExpenseTable";

const Expenses = () => {
  return (
    <Box m="1.5rem 2.5rem">
      <Header
        title={"Expenses"}
        subtitle="Contains data related to Expenses"
        button={<AddExpense />}
      />

      <ExpenseAnalytics />
      <Cards />

      <ExpenseTable />

      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        marginTop={2}
      ></Box>
    </Box>
  );
};

export default Expenses;
